"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const Link = ({ children, src }) => {
    return jsx_runtime_1.jsx(rpdf_renderer_1.Link, Object.assign({ src: src }, { children: children }), void 0);
};
exports.Link = Link;
//# sourceMappingURL=link.js.map